import { INIT_DATA } from './state'
import {set, values} from 'lodash-es'

export default {
// =================================================
  setSignInfo (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },
  setAuditInfo (state, payload) {
    state.auditInfo = payload
  },
  resetAudit (state) {
    state.auditInfo = {}
    // state.auditStatus = {}
  },
  pickSignType (state, type) {
    state.signType = type
  },
  setCheckStatus (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },
  setRequired (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },
  setCompleteStatus (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },
  setContractGlobalStatus (state, payload) {
    state.contractGlobal = payload
  },
  // 门店关联主体的信息
  setRelatedParty (state, payload) {
    const { data, path } = payload
    set(state, path, data)
    console.log('根据shopId获取主体的信息========================》', state)
  },
  updateSignRelationShopList (state, payload) {
    state.relation = payload
  },
  // =================================================
  setProgress (state, { propgress }) {
    state.propgress = { ...propgress }
  },

  resetSignInfo (state, payload) {
    state.signForm = { ...INIT_DATA }
  },

  updateAuditInfo (state, { auditInfo, shopList, shopId }) {
    state.auditInfo = {
      ...auditInfo,
      shop: shopList.filter(item => item.shopId === shopId)
    }
  },
  updateAuditStatus (state, auditStatus) {
    state.auditStatus = auditStatus
  },

  resetAudit (state) {
    state.auditInfo = {}
    state.auditStatus = {}
  },

  updateTaxSourceTypeConfig (state, payload) {
    state.configs = {
      ...state.configs,
      ...payload
    }
  },

  updateSignListOpenCityList (state, data) {
    state.openCity = values(data).map(item => {
      return {
        label: item.cityName,
        value: item.cityId
      }
    })
  }
}
